import Vue from "vue";

export default Vue.extend({
  template: "<span>{{ changedValue }}</span>",
  data() {
    return {
      changedValue: "",
    };
  },
  created() {
    this.valueToText(this.params);
  },
  methods: {
    valueToText(params) {
      var values = null;
      if (params.values !== undefined) {
        values = params.values;
      } else {
        values = params.colDef.cellEditorParams.values;
      }
      for (let i = 0; i < values.length; i++) {
        if (params.value === values[i].value) {
          this.changedValue = values[i].text;
          break;
        }
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/common/cellComboRenderer.js